import { AccordionProps, Grid, ThemeProvider, Typography } from "@mui/material";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ExpandMore";
import { DhlTheme } from "../../Theme/DhlMuiTheme";
import { StyledAccordion } from "./StyledAccordion";
import { MdmAccordionSummary } from "./MdmAccordionSummary";
import { StyledAccordionDetails } from "./StyledAccordionDetails";

export interface MdmAccordionProps extends AccordionProps {
  readonly title: string;
  readonly controls: JSX.Element[];
}

function MdmAccordion({ title, controls, ...props }: MdmAccordionProps) {
  return (
    <ThemeProvider theme={DhlTheme}>
      <StyledAccordion disableGutters {...props}>
        <MdmAccordionSummary
          expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "1.5rem" }} />}
          isExpanded={props.expanded}
        >
          <Grid container columnSpacing={4} mt={0.5} alignItems="center">
            <Grid item xs={8}>
              <Typography>{title}</Typography>
            </Grid>
            <Grid item xs={4} container justifyContent="flex-end">
              {controls}
            </Grid>
          </Grid>
        </MdmAccordionSummary>
        <StyledAccordionDetails>{props.children}</StyledAccordionDetails>
      </StyledAccordion>
    </ThemeProvider>
  );
}

export default MdmAccordion;
